module.exports = __webpack_public_path__ + "img/gb-sct.1515d587.svg";